import React from "react";
import { Textarea } from "../../components/ui/textarea";

const MAX_CHARS = 400;
const MAX_LINES = 10;

const TEMPLATES = [
    (name) => `To ${name}, may your adventures be as big as your imagination.`,
    (name) => `For ${name} — you are the hero of every story.`,
    (name) => `Wishing ${name} a lifetime of wonder and adventure.`,
];

const OPTIONS = [
    { id: "custom", title: "Write your own message", sub: "A personal note printed on its own page" },
    { id: "template", title: "Choose a starter message", sub: "Pick one, edit it if you like" },
    { id: "skip", title: "Skip this page", sub: "Go straight from cover to story" },
];

function capText(value) {
    let v = value.slice(0, MAX_CHARS);
    const lines = v.split("\n");
    if (lines.length > MAX_LINES) v = lines.slice(0, MAX_LINES).join("\n");
    return v;
}

export function DedicationSection({ childName, choice, setChoice, text, setText }) {
    const name = childName || "your child";
    const onPick = (id) => {
        setChoice(id);
        if (id === "skip") setText("");
        if (id === "custom" && text && TEMPLATES.some((t) => t(name) === text)) setText("");
    };
    return (
        <div className="pt-6 mt-6 border-t border-border" data-testid="sf-form-dedication">
            <h2 className="font-serif text-2xl text-primary mb-1">Dedication page</h2>
            <p className="text-xs text-muted-foreground mb-5">
                A free, optional page printed right after the cover — a message from you to {name}.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                {OPTIONS.map((opt) => (
                    <button
                        key={opt.id}
                        type="button"
                        onClick={() => onPick(opt.id)}
                        data-testid={`sf-form-dedication-${opt.id}`}
                        className={`text-left px-4 py-3 rounded-xl border transition-colors ${choice === opt.id ? "border-primary bg-primary/5" : "border-border bg-muted/30 hover:bg-muted/50"}`}
                    >
                        <p className="text-sm text-foreground">{opt.title}</p>
                        <p className="text-xs text-muted-foreground mt-0.5">{opt.sub}</p>
                    </button>
                ))}
            </div>

            {choice === "template" && (
                <div className="mt-3 space-y-2" data-testid="sf-form-dedication-templates">
                    {TEMPLATES.map((tpl, i) => {
                        const msg = tpl(name);
                        return (
                            <button
                                key={i}
                                type="button"
                                onClick={() => setText(msg)}
                                data-testid={`sf-form-dedication-template-${i}`}
                                className={`w-full text-left px-4 py-3 rounded-xl border text-sm italic transition-colors ${text === msg ? "border-primary bg-primary/5 text-foreground" : "border-border bg-muted/30 hover:bg-muted/50 text-muted-foreground"}`}
                            >
                                &ldquo;{msg}&rdquo;
                            </button>
                        );
                    })}
                </div>
            )}

            {(choice === "custom" || choice === "template") && (
                <div className="mt-3">
                    <Textarea
                        value={text}
                        onChange={(e) => setText(capText(e.target.value))}
                        placeholder={choice === "custom" ? `e.g., To ${name}, love always — Mom & Dad` : "Pick a starter above, then edit it here"}
                        rows={4}
                        data-testid="sf-form-dedication-text"
                        className="bg-muted/40 border-border resize-none"
                    />
                    <p className="text-xs text-muted-foreground mt-1 text-right" data-testid="sf-form-dedication-counter">
                        {text.length}/{MAX_CHARS} characters
                    </p>
                </div>
            )}

            {choice === "skip" && (
                <p className="text-xs text-muted-foreground mt-3" data-testid="sf-form-dedication-skip-note">
                    No dedication page — the book will go straight from cover to story.
                </p>
            )}
        </div>
    );
}
